module.exports = __webpack_public_path__ + "img/icon_road_01.bac60c36.png";